import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "flex justify-center px-8 mt-16" };
const _hoisted_2 = { class: "ml-8 lg:ml-48 w-81" };
const _hoisted_3 = { class: "flex" };
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('views.teams.new')
};
import { computed, ref, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useFullWidth } from '@/composables/useFullWidth';
import { useWorkspace } from '@/composables/workspaces';
import { useNewTeamStore } from '@/pinia_stores/newTeam';
import { useSeatsValidations } from '@/composables/seatsValidations';
import InvitesForm from '@/components/workspaces/InvitesForm.vue';
import MobileNotSupported from '@/components/MobileNotSupported.vue';
import NumberStepper from '@/components/progress/NumberStepper.vue';
import ProgressBar from '@/components/progress/ProgressBar.vue';
import Scaffold from '@/components/Scaffold.vue';
import SeatsForm from '@/components/workspaces/SeatsForm.vue';
import TeamForm from '@/components/workspaces/TeamForm.vue';
import WorkspaceImage from '@/components/workspaces/WorkspaceImage.vue';
import WorkspaceSubheader from '@/components/workspaces/WorkspaceSubheader.vue';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'New',
    setup(__props) {
        useFullWidth();
        const newTeamStore = useNewTeamStore();
        const { workspace } = useWorkspace();
        const store = useStore();
        const router = useRouter();
        const { users, invitesSearchTerm, seatsToBuy } = storeToRefs(newTeamStore);
        const { hasToBuySeats, requiredSeatsToBuy, isSeatsToBuyValid } = useSeatsValidations({
            selectedUsers: users,
            searchTerm: invitesSearchTerm,
            seatsToBuy,
            workspace
        });
        onUnmounted(() => newTeamStore.$reset());
        const hasInvalidEmails = computed(() => newTeamStore.stepName === 'invites' && !newTeamStore.areAllEmailsValid);
        const hasInvalidSeatsAmount = computed(() => newTeamStore.stepName === 'buySeats' && !isSeatsToBuyValid.value);
        const isLoading = ref(false);
        async function handleSubmit() {
            isLoading.value = true;
            if (newTeamStore.seatsToBuy > 0) {
                const totalSeats = workspace.value.seats + newTeamStore.seatsToBuy;
                await store.dispatch('updateWorkspace', {
                    seats: totalSeats,
                    workspaceId: workspace.value.id
                });
            }
            newTeamStore.createTeam(workspace.value.id);
            isLoading.value = false;
        }
        function decrementStep() {
            if (newTeamStore.stepName === 'teamName') {
                router.push({ name: 'showWorkspace', params: { workspaceId: workspace.value.id } });
            }
            else {
                newTeamStore.decrementStep();
            }
        }
        return (_ctx, _cache) => {
            const _component_section_heading = _resolveComponent("section-heading");
            const _component_text_button = _resolveComponent("text-button");
            const _component_pill_button = _resolveComponent("pill-button");
            const _directive_tooltip = _resolveDirective("tooltip");
            return (_unref(workspace))
                ? (_openBlock(), _createBlock(Scaffold, {
                    key: 0,
                    class: "h-screen pt-10"
                }, {
                    subheader: _withCtx(() => [
                        _createVNode(WorkspaceSubheader)
                    ]),
                    content: _withCtx(() => [
                        _createVNode(_component_section_heading, {
                            class: "pt-5",
                            heading: _ctx.$t(`${_unref(newTeamStore).stepName}.heading`),
                            subheading: _ctx.$t(`${_unref(newTeamStore).stepName}.subheading`)
                        }, null, 8, ["heading", "subheading"]),
                        _createElementVNode("div", _hoisted_1, [
                            _createVNode(WorkspaceImage, {
                                step: _unref(newTeamStore).step + 1
                            }, null, 8, ["step"]),
                            _createElementVNode("div", _hoisted_2, [
                                (_unref(newTeamStore).stepName === 'teamName')
                                    ? (_openBlock(), _createBlock(TeamForm, { key: 0 }))
                                    : _createCommentVNode("", true),
                                (_unref(newTeamStore).stepName === 'invites')
                                    ? (_openBlock(), _createBlock(InvitesForm, { key: 1 }))
                                    : _createCommentVNode("", true),
                                (_unref(newTeamStore).stepName === 'buySeats')
                                    ? (_openBlock(), _createBlock(SeatsForm, { key: 2 }))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ]),
                    footer: _withCtx(() => [
                        _createVNode(ProgressBar, null, {
                            left: _withCtx(() => [
                                _createVNode(NumberStepper, {
                                    "current-step": _unref(newTeamStore).step,
                                    steps: [
                                        { number: 1, title: _ctx.$t('teamName.title') },
                                        { number: 2, title: _ctx.$t('invites.title') },
                                        ...(_unref(hasToBuySeats) ? [{ number: 3, title: _ctx.$t('buySeats.title') }] : [])
                                    ]
                                }, null, 8, ["current-step", "steps"])
                            ]),
                            right: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, [
                                    _createVNode(_component_text_button, {
                                        inverted: "",
                                        onClick: decrementStep
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('previous')), 1)
                                        ], undefined, true),
                                        _: 1
                                    }),
                                    (_unref(newTeamStore).stepName === 'teamName' ||
                                        (_unref(newTeamStore).stepName === 'invites' && _unref(hasToBuySeats)))
                                        ? _withDirectives((_openBlock(), _createBlock(_component_pill_button, {
                                            key: 0,
                                            kind: "secondary",
                                            disabled: !_unref(newTeamStore).canAdvanceStep || _unref(hasInvalidEmails),
                                            class: "ml-16",
                                            onClick: _unref(newTeamStore).incrementStep
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('next')), 1)
                                            ], undefined, true),
                                            _: 1
                                        }, 8, ["disabled", "onClick"])), [
                                            [_directive_tooltip, (!_unref(newTeamStore).canAdvanceStep && _ctx.$t(_unref(newTeamStore).advanceDisabledReason)) || (_unref(hasInvalidEmails) && _ctx.$t('invalid_emails'))]
                                        ])
                                        : _withDirectives((_openBlock(), _createBlock(_component_pill_button, {
                                            key: 1,
                                            disabled: _unref(hasInvalidEmails) || _unref(hasInvalidSeatsAmount),
                                            loading: isLoading.value,
                                            kind: "secondary",
                                            class: "ml-16",
                                            onClick: handleSubmit
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('create_team')), 1)
                                            ], undefined, true),
                                            _: 1
                                        }, 8, ["disabled", "loading"])), [
                                            [_directive_tooltip,
                                                (_unref(hasInvalidEmails) && _ctx.$t('invalid_emails')) ||
                                                    (_unref(hasInvalidSeatsAmount) &&
                                                        (_unref(requiredSeatsToBuy) > 1
                                                            ? _ctx.$t('invalid_seats_amount', { seats: _unref(requiredSeatsToBuy) })
                                                            : _ctx.$t('invalid_one_seat_amount')))
                                            ]
                                        ])
                                ])
                            ]),
                            _: 1
                        })
                    ]),
                    floating: _withCtx(() => [
                        _createVNode(MobileNotSupported)
                    ]),
                    _: 1
                }))
                : _createCommentVNode("", true);
        };
    }
});
